<ng-container *ngIf="authHash$ | async as authHash">
  <mg-student-schedule [hash]="authHash"></mg-student-schedule>
</ng-container>
